'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var convertToJcamp = require('convert-to-jcamp');
var jcampconverter = require('jcampconverter');

function getAnnotations(spectrum, options = {}) {
  const { fillColor = "green", strokeColor = "red", creationFct } = options;
  const peaks = spectrum.peaks;
  if (!peaks) return [];
  let annotations = peaks.map(peak => {
    var annotation = {
      line: 1,
      type: "rect",
      strokeColor: strokeColor,
      strokeWidth: 0,
      fillColor: fillColor
    };
    if (creationFct) {
      creationFct(annotation, peak);
    }
    switch (spectrum.mode) {
      case ABSORBANCE:
        annotationAbsorbance(annotation, peak);
        break;
      case TRANSMITTANCE:
        annotationTransmittance(annotation, peak, 1);
        break;
      case PERCENT_TRANSMITTANCE:
        annotationTransmittance(annotation, peak, 100);
        break;
    }
    return annotation;
  });

  return annotations;
}

function annotationTransmittance(annotation, peak, factor = 1) {
  annotation.label = [
    {
      text: String(peak.wavelength),
      size: "12px",
      anchor: "middle",
      color: "red",
      position: {
        x: peak.wavelength,
        y: peak.transmittance * factor,
        dy: "23px"
      }
    }
  ];
  annotation.position = [
    {
      x: peak.wavelength,
      y: peak.transmittance * factor,
      dy: "10px",
      dx: "-1px"
    },
    {
      x: peak.wavelength,
      y: peak.transmittance * factor,
      dy: "5px",
      dx: "1px"
    }
  ];
}

function annotationAbsorbance(annotation, peak) {
  annotation.label = [
    {
      text: String(peak.wavelength),
      size: "18px",
      anchor: "middle",
      color: "red",
      position: {
        x: peak.wavelength,
        y: peak.absorbance,
        dy: "-15px"
      }
    }
  ];
  annotation.position = [
    {
      x: peak.wavelength,
      y: peak.absorbance,
      dy: "-10px",
      dx: "-1px"
    },
    {
      x: peak.wavelength,
      y: peak.absorbance,
      dy: "-5px",
      dx: "1px"
    }
  ];
}

function toJcamp(spectrum) {
  let meta = {
    // title: spectrum.sampleMeta.cellname,
    owner: "",
    origin: "",
    type: "IV curve",
    xUnit: "difference in electric potential [V]",
    yUnit: "intensity [A]",
    info: spectrum.meta
  };

  return convertToJcamp.fromJson(spectrum.data, meta);
}

/**
 * Class allowing manipulate one UV spectrum
 * @class spectrum
 * @param {object} [data={}] - object containing a spectrum
 * @param {Array} [data.x=[]] - voltage
 * @param {Array} [data.y=[]] - intensity
 */
class Spectrum {
  constructor(data = { x: [], y: [] }, meta = {}, id = Math.random()) {
    this.data = data;
    this.meta = meta;
    this.id = id;
  }

  getXLabel() {
    return 'Voltage [V]';
  }

  getYLabel() {
    return 'Intensity [A]';
  }
}

Spectrum.prototype.getAnnotations = function(options) {
  return getAnnotations(this, options);
};

Spectrum.prototype.getData = function(options = {}) {
  const { xFactor = 1, yFactor = 1 } = options;
  return {
    x: this.data.x.map(x => x * xFactor),
    y: this.data.y.map(y => y * yFactor)
  };
};

Spectrum.prototype.toJcamp = function() {
  return toJcamp(this);
};

class Spectra {
  constructor() {
    this.data = [];
  }

  /**
   * Add a spectrum
   * @param {Spectrum} spectrum
   * @param {string} id
   * @param {object} [meta={}]
   */
  addSpectrum(spectrum, id, meta = {}) {
    let index = this.getSpectrumIndex(id);
    if (index === undefined) index = this.data.length;
    this.data[index] = {
      spectrum,
      id,
      meta
    };
  }

  removeSpectrum(id) {
    let index = this.getSpectrumIndex(id);
    if (index === undefined) return undefined;
    return this.data.splice(index, 1);
  }

  getSpectrumIndex(id) {
    if (!id) return undefined;
    for (let i = 0; i < this.data.length; i++) {
      let spectrum = this.data[i];
      if (spectrum.id === id) return i;
    }
    return undefined;
  }
}

function fromSIV(content) {
  let allLines = content.split(/[\r\n]+/);
  let sampleMeta = parseS(allLines.filter(line => line.match(/X S_/)));
  let instrumentMeta = parseV(allLines.filter(line => line.match(/X V_/)));
  let date = parseDate(allLines.filter(line => line.match(/X d_t/))[0]);

  let parts = content.split('WAVES	');
  let spectra = [];

  console.log(parts);
  for (let part of parts) {
    let lines = part.split(/[\r\n]+/);
    console.log(lines.length);
    let ys = lines
      .filter(line => line.match(/^[\t 0-9.eE-]+$/))
      .map(line => Number(line));
    if (ys.length < 10) continue;

    let kind = lines[0].trim();
    let metaLines = lines
      .filter(line => line.match(/^X /))
      .map(line => line.substring(2));
    console.log(metaLines);
    let axis = parseScale(metaLines[0], ys.length);

    if (!axis.x || axis.x.unit !== 'V') {
      console.log('Unknown X axis:', axis.kind, axis.unit);
      continue;
    }
    if (!axis.y || axis.y.unit !== 'A') {
      console.log('Unknown Y axis:', axis.kind, axis.unit);
      continue;
    }
    // let note = parseNote(metaLines[1]);
    let xs = axis.x.values;
    let data = {
      x: xs,
      y: ys
    };

    let meta = {
      ...sampleMeta,
      date,
      experiment: kind,
      ...instrumentMeta
    };
    spectra.push(new Spectrum(data, meta));
  }
  return spectra;
}

function parseDate(line) {
  let dateString = line
    .replace('X d_t=', '')
    .trim()
    .replace(/"/g, '');
  let date = new Date(dateString);
  return date;
}

function parseScale(line, nbValues) {
  let result = {};
  line = line.replace(/ ([xy]) /g, ',$1,');
  let parts = line.split('; ');
  console.log('---------');
  console.log(parts);
  for (let part of parts) {
    let parsedPart = parseScalePart(part, nbValues);
    console.log(parsedPart);
    result[parsedPart.axis] = parsedPart;
  }
  return result;
}

function parseS(lines) {
  let result = {};
  for (let line of lines) {
    let key = line.replace(/X ._([^=]*)=(.*)/, '$1').trim();
    key = getFieldName(key);
    let value = line.replace(/X ._([^=]*)=(.*)/, '$2').trim();
    value = value.replace(/^"(.*)"$/, '$1');
    if (!isNaN(value)) value = Number(value);
    result[key] = value;
  }
  return result;
}

function parseV(lines) {
  let result = {};
  for (let line of lines) {
    let key = line.replace(/X ._([^=]*)=(.*)/, '$1').trim();
    key = getFieldName(key);
    let value = line.replace(/X ._([^=]*)=(.*)/, '$2').trim();
    value = value.replace(/^"(.*)"$/, '$1');
    if (!isNaN(value)) value = Number(value);
    result[key] = value;
  }
  return result;
}

function parseScalePart(scale, nbValues) {
  let parts = scale.split(',');
  let result = {};
  result.axis = parts[1];
  result.kind = parts[0];
  result.unit = parts[4].replace(/"/g, '');
  if (result.kind === 'SetScale/P') {
    let from = Number(parts[2]);
    let step = Number(parts[3]);
    let values = [];
    for (let i = 0; i < nbValues; i++) {
      values.push(from);
      from += step;
      result.values = values;
    }
  }
  return result;
}

function getFieldName(key) {
  const mapping = {
    CE: 'counterElectrodeType',
    Calibrationfile: 'calibrationFile',
    Username: 'username',
    WE: 'workingElectrodeGlass',
    cellname: 'cellname',
    electrolyte: 'electrolyteZ960',
    layer: 'semicondutorLayer',
    specification: 'remarks',
    temp: 'workingTemperature',
    type: 'typeOfCell',
    AR: 'cellActiveArea',
    IT: 'powerIn'
  };
  return mapping[key] || key;
}

/**
 * Creates a new Chromatogram element based in a JCAMP string
 * @param {string} jcamp - String containing the JCAMP data
 * @return {Spectrum} - New class element with the given data
 */
function fromJcamp(jcamp) {
  const converted = jcampconverter.convert(jcamp, {
    xy: true,
    keepRecordsRegExp: /.*/,
    canonicDataLabels: false,
    dynamicTyping: true
  });

  let data = converted.spectra[0].data[0];
  let info = converted.info;
  let meta = {};
  for (let key of Object.keys(info).filter(key => key.startsWith("$"))) {
    meta[key.substr(1)] = info[key];
  }
  return new Spectrum(data, meta);
}

exports.Spectra = Spectra;
exports.Spectrum = Spectrum;
exports.fromJcamp = fromJcamp;
exports.fromSIV = fromSIV;
